/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.paytypes.leave
 * @name TimePayrollLeaveEditCtrl
 */
angular.module('mercury.modules.time.payroll.paytypes.leave')
.controller('TimePayrollLeaveEditCtrl', ["$scope", "TimePayrollLeave", function($scope, TimePayrollLeave) {
  $scope.activeTab = 'details';

  if (!$scope.selectedPaytype) {
    $scope.selectedPaytype = {
      description: '',
      isTaxable: true,
      defaultRate: 0,
      defaultQuantity: 0,
      autoAdd: 2,
      defaultStaff: [],
      defaultRoles: []
    };
  }

  $scope.enabledStaff = {};
  angular.forEach($scope.selectedPaytype.defaultStaff, function(paytypeStaff) {
    $scope.enabledStaff[paytypeStaff.staffMemberId] = true;
  });

  $scope.enabledRoles = {};
  angular.forEach($scope.selectedPaytype.defaultRoles, function(paytypeRoles) {
    $scope.enabledRoles[paytypeRoles.staffRoleId] = true;
  });

  $scope.quantityTypes = [
    {id: 0, description: 'Do not track'},
    {id: 1, description: 'Holidays Act'},
    {id: 2, description: 'Percent of Gross'}
  ];

  $scope.autoAddOptions = [
    {description: 'None', id: 1},
    {description: 'All Employees', id: 2},
    {description: 'Selected Employees', id: 3},
    {description: 'Selected Roles', id: 4}
  ];

  $scope.save = function() {
    $scope.selectedPaytype.defaultStaff = [];
    $scope.selectedPaytype.defaultRoles = [];

    if ($scope.selectedPaytype.autoAdd == 3) {
      angular.forEach($scope.enabledStaff, function(enabled, staffMemberId) {
        if (enabled) {
          $scope.selectedPaytype.defaultStaff.push({staffMemberId: staffMemberId});
        }
      });
    } else if ($scope.selectedPaytype.autoAdd == 4) {
      angular.forEach($scope.enabledRoles, function(enabled, staffRoleId) {
        if (enabled) {
          $scope.selectedPaytype.defaultRoles.push({staffRoleId: staffRoleId});
        }
      });
    }

    var toSave = angular.copy($scope.selectedPaytype);

    $scope.saving = TimePayrollLeave.save(toSave);
    $scope.saving.then(function(result) {
      if ($scope.selectedPaytype.id) {
        $scope.$close(toSave);
      } else {
        $scope.$close(result);
      }
    });
  };

  $scope.delete = function() {
    $scope.selectedPaytype.datestampDeleted = moment().format();

    $scope.deleting = TimePayrollLeave.save($scope.paytype);
    $scope.deleting.then(function() {
      $scope.$close($scope.deleting);
    });
  };
}]);
